import { createSlice } from "@reduxjs/toolkit";

/** How the user reached the page on screen from another page in the app. */
export interface PageArrival {
  /** The route pattern of the page before, such as `/experiments/:id`. */
  previousPage: string;
  /** The entry point the link named in its router state, if it named one. */
  entryPoint: string | null;
  /** The click that navigated was inside the side nav. */
  fromSideNav: boolean;
}

export interface NavigationState {
  /** The route pattern on screen. Null before the first page is shown. */
  currentPage: string | null;
  /** Null on the page the app loaded on, which a link did not lead to. */
  arrival: PageArrival | null;
}

const initialState: NavigationState = {
  currentPage: null,
  arrival: null,
};

const slice = createSlice({
  name: "navigation",
  initialState,
  reducers: (create) => ({
    pageShown: create.reducer<{
      page: string;
      entryPoint: string | null;
      fromSideNav: boolean;
    }>((state, { payload }) => {
      state.arrival =
        state.currentPage === null
          ? null
          : {
              previousPage: state.currentPage,
              entryPoint: payload.entryPoint,
              fromSideNav: payload.fromSideNav,
            };
      state.currentPage = payload.page;
    }),
  }),
  selectors: {
    getPageArrival: (state) => state.arrival,
  },
});

export const navigationReducer = slice.reducer;

export const { pageShown } = slice.actions;

export const { getPageArrival } = slice.selectors;
